import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { isUserSigninSucceed } from "../../store/selectors";
import { logOutAction } from "../../store/Signin/actions";
import { Dispatch, RootState } from "../../store/types";
import { ChatProvider } from "../Reusable/UseUserChat";
import ContentSection from "./ContentSection";
import { FeatureHeader } from "./FeatureHeader";
import SideNavMenu from "./SideNavMenu";

export interface FeatureProps {
  logOutAction: typeof logOutAction;
}

const _Feature: React.FC<FeatureProps> = ({ logOutAction }) => {
  const [sideNavShow, setSideNavShow] = useState(true);
  const authenticated = localStorage.getItem("jwtToken");
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!localStorage.getItem("jwtToken")) logOutAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!authenticated && <Navigate to="/signin" replace />}
      {authenticated && (
        <div className="h-screen bg-background font-sans flex" dir={i18n.dir()}>
          <ChatProvider>
            <SideNavMenu
              sideNavShow={sideNavShow}
              setSideNavShow={setSideNavShow}
            />
            <div className="flex-1 flex flex-col min-w-0 items-center">
              <FeatureHeader
                sideNavShow={sideNavShow}
                setSideNavShow={setSideNavShow}
              />
              <ContentSection sideNavShow={sideNavShow} />
            </div>
          </ChatProvider>
        </div>
      )}
    </>
  );
};

export const Feature = connect(
  (state: RootState) => ({
    isUserSigninSucceed: isUserSigninSucceed(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreators(
      {
        logOutAction: logOutAction,
      },
      dispatch
    )
)(_Feature);

export default _Feature;
